import {
  type CarrierRequestService,
  carrierRequestServices,
} from '@engine/models/admin'

import { type RangeKey } from '#utils/timeRanges'

import { type BaseFilterValues, useReportFilters } from './useReportFilters'

export type { CarrierRequestService }

const serviceLabels: Record<CarrierRequestService, string> = {
  tracking: 'Tracking',
  rating: 'Rating',
  profinder: 'ProFinder',
  ebol: 'eBOL',
  dispatching: 'Dispatching',
  documents: 'Documents',
  invoice: 'Invoice',
  provisioning: 'Provisioning',
}

export const carrierRequestServiceOptions = carrierRequestServices.map(
  value => ({ value, label: serviceLabels[value] }),
)

export interface CarrierRequestFilterValues extends BaseFilterValues {
  service: CarrierRequestService[]
}

export const useCarrierRequestFilters = (
  options: {
    defaultService?: CarrierRequestService[]
    defaultRange?: RangeKey
    debounceMs?: number
  } = {},
) => {
  return useReportFilters<CarrierRequestFilterValues>({
    defaultRange: options.defaultRange,
    debounceMs: options.debounceMs,
    initFromParams: searchParams => {
      const selectedServices = searchParams.getAll(
        'service',
      ) as CarrierRequestService[]
      return {
        service:
          selectedServices.length > 0
            ? selectedServices
            : options.defaultService || ['tracking'],
      }
    },
    toApiFilters: filters => ({
      service: filters.service,
    }),
    syncToParams: (params, filters) => {
      params.delete('service')
      filters.service.forEach(service => params.append('service', service))
    },
  })
}
